export enum PromoRuleTypeEnum {
  MINIMUM_ORDER_SALES_AMOUNT = "minimum_order_sales_amount",
  MINIMUM_ORDER_QUANTITY = "minimum_order_quantity",
  MINIMUM_PRODUCT_ORDER_QUANTITY = "minimum_product_order_quantity",
  PAYMENT_METHOD = "payment_method",
  SHIPPING_DISCOUNT = "shipping_discount",
}

export enum PromoLabelEnum {
  MINIMUM_ORDER_SALES_AMOUNT = "minimum_order_sales_amount",
  MINIMUM_ORDER_QUANTITY = "minimum_order_quantity",
  PRODUCT_DISCOUNT = "product_discount",
  PRODUCT_BUY_N_GET_M = "product_buy_n_get_m",
  PRODUCT_BUNDLING = "product_bundling",
  PAYMENT_METHOD = "payment_method",
  LOYALTY_POINTS = "loyalty_points",
  ON_THE_FLY_DISCOUNT = "on_the_fly_discount",
  SHIPPING_DISCOUNT = "shipping_discount",
  ORDER_VOUCHER = "order_voucher",
  PRODUCT_VOUCHER = "product_voucher",
}

export default PromoRuleTypeEnum;
